import { Link } from "react-router-dom";
import { ArrowRight, Shield, Cloud, Monitor } from "lucide-react";
import { Button } from "@/components/ui/button";
import mascotImage from "@/assets/coblynau-mascot.png";

const Hero = () => {
  return (
    <section className="relative overflow-hidden pt-24 pb-16 lg:pt-32 lg:pb-24">
      {/* Background gradient */}
      <div className="absolute inset-0 gradient-earth -z-10" />
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-sage/20 to-transparent -z-10" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div className="animate-slide-up">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 text-primary text-sm font-medium mb-6">
              <span className="w-2 h-2 rounded-full bg-primary animate-pulse" />
              Trusted IT Partner in Swansea
            </div>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-foreground leading-tight mb-6">
              Guiding Your Business to{" "}
              <span className="text-gradient" aria-label="Digital Success">Digital Success</span>
            </h1>

            <p className="text-lg text-muted-foreground mb-8 max-w-xl">
              Like the mythical Coblynau who guided miners to precious ore, we lead your business to technology solutions that drive growth and success.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-12">
              <Button asChild size="lg" className="shadow-elevated">
                <Link to="/contact">
                  Get a Free Consultation
                  <ArrowRight className="ml-2 h-4 w-4" />
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg">
                <Link to="/services">Explore Our Services</Link>
              </Button>
            </div>

            {/* Quick Stats */}
            <div className="grid grid-cols-3 gap-6">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
                  <Shield className="h-5 w-5 text-primary" />
                </div>
                <div>
                  <p className="text-2xl font-bold text-foreground">100%</p>
                  <p className="text-xs text-muted-foreground">Secure</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
                  <Cloud className="h-5 w-5 text-primary" />
                </div>
                <div>
                  <p className="text-2xl font-bold text-foreground">24/7</p>
                  <p className="text-xs text-muted-foreground">Support</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
                  <Monitor className="h-5 w-5 text-primary" />
                </div>
                <div>
                  <p className="text-2xl font-bold text-foreground">Local</p>
                  <p className="text-xs text-muted-foreground">Experts</p>
                </div>
              </div>
            </div>
          </div>

          {/* Mascot Image */}
          <div className="relative flex justify-center lg:justify-end animate-fade-in">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-br from-primary/20 to-moss/20 rounded-full blur-3xl scale-110" />
              <img
                src={mascotImage}
                alt="Coblynau - Our friendly IT helper mascot"
                className="relative w-full max-w-md lg:max-w-lg animate-float"
                width={512}
                height={512}
                fetchPriority="high"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
